import React, { useState, useEffect } from "react";
import "../../../css/WeekLinePay.css";
import WeekTransPay from "./WeekTransPay";
import Weather from "../../weather/WeatherView";

const WeekLinePay = () => {
  const [page, setPage] = useState(1);

  const handlePage = (item: number) => {
    setPage(item + page);
  };

  return (
    <div className="per_week_line_container">
      <WeekTransPay handlePage={handlePage} page={page} />
      <Weather page={page} />
    </div>
  );
};

export default WeekLinePay;
